import { Col, Row, Switch } from "antd";
import { get, set } from "lodash";
import { useTranslation } from "react-i18next";

import { MdOutlineFreeCancellation } from "react-icons/md";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";

const MemberShip = ({
  formProps,
  setPercent,
  setFieldValue,
  disabled,
  setDisabled,
  isFieldRequired,
  initialValues,
  errors,
}) => {
  // useEffect(() => setPercent(initialValues), [disabled]);
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const MEMBERSHIP = t(
    "SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.LAFPAC_MEMBERSHIP",
    {
      returnObjects: true,
    },
  );

  const MEMBERSHIP_STATUS = {
    [true]: () => {
      set(
        initialValues,
        "project.contact.fields.requestLafpacMemberShip",
        true,
      );
      set(initialValues, "project.contact.fields.alreadyLafpacMember", false);
      set(initialValues, "project.contact.fields.lafpacMemberShipNumber", null);
      setDisabled((prev) => ({
        ...prev,
        project: {
          ...prev?.project,
          contact: {
            ...prev?.project?.contact,
            fields: {
              ...prev?.project?.contact?.fields,
              lafpacMemberShipNumber: true,
            },
          },
        },
      }));
    },
    [false]: () => {
      set(
        initialValues,
        "project.contact.fields.requestLafpacMemberShip",
        false,
      );
      set(initialValues, "project.contact.fields.alreadyLafpacMember", true);
      setDisabled((prev) => ({
        ...prev,
        project: {
          ...prev?.project,
          contact: {
            ...prev?.project?.contact,
            fields: {
              ...prev?.project?.contact?.fields,
              lafpacMemberShipNumber: false,
            },
          },
        },
      }));
    },
  };

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.LAFPAC_MEMBERSHIP}-section`}
    >
      <Form type="vertical" title={MEMBERSHIP.TITLE}>
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <div className="d-flex justify--between">
              <span className="contact-stepper__content--radio--title">
                {MEMBERSHIP.REQUEST_MEMBERSHIP}
              </span>
              <Switch
                className="contact-stepper__content--radio--switch button__switch"
                checkedChildren={MEMBERSHIP.OPTIONS.YES}
                unCheckedChildren={MEMBERSHIP.OPTIONS.NO}
                defaultChecked={get(
                  initialValues,
                  "project.contact.fields.requestLafpacMemberShip",
                )}
                checked={get(
                  initialValues,
                  "project.contact.fields.requestLafpacMemberShip",
                )}
                onBlur={() => setPercent(initialValues)}
                onChange={(e) => MEMBERSHIP_STATUS[e]()}
              />
            </div>
          </Col>
          <Col lg={24} xs={24}>
            <div className="d-flex justify--between">
              <span className="contact-stepper__content--radio--title">
                {MEMBERSHIP.ALREADY_MEMBER}
              </span>
              <Switch
                className="contact-stepper__content--radio--switch button__switch"
                checkedChildren={MEMBERSHIP.OPTIONS.YES}
                unCheckedChildren={MEMBERSHIP.OPTIONS.NO}
                defaultChecked={get(
                  initialValues,
                  "project.contact.fields.alreadyLafpacMember",
                )}
                checked={get(
                  initialValues,
                  "project.contact.fields.alreadyLafpacMember",
                )}
                onBlur={() => setPercent(initialValues)}
                onChange={(e) => MEMBERSHIP_STATUS[!e]()}
              />
            </div>
          </Col>
          {get(initialValues, "project.contact.fields.alreadyLafpacMember") && (
            <>
              <Col lg={24} xs={24}>
                <Input
                  placeholder={MEMBERSHIP.MEMBERSHIP_NUMBER.PLACEHOLDER}
                  label={MEMBERSHIP.MEMBERSHIP_NUMBER.LABEL}
                  icon={<MdOutlineFreeCancellation size={16} />}
                  defaultValue={get(
                    initialValues,
                    "project.contact.fields.lafpacMemberShipNumber",
                  )}
                  errors={
                    errors["project.contact.fields.lafpacMemberShipNumber"]
                  }
                  touched={true}
                  onBlur={() => setPercent(initialValues)}
                  onChange={({ target: { value } }) => {
                    set(
                      initialValues,
                      "project.contact.fields.lafpacMemberShipNumber",
                      value,
                    );
                  }}
                  required={true}
                />
              </Col>
            </>
          )}
        </Row>
      </Form>
    </div>
  );
};

export default MemberShip;
